<div class="flex-column height-100 bg-col-w p-t-16 p-t-8-s p-t-8-m">
    <div class="flex flex-middle p-l-10 p-r-10 p-r-4-s p-l-4-s">
        <h6 class="flex-grow flex flex-bottom">
            <span [class]="smallText() ? 'h4' : 'h3'"><ng-content select="[dialogTitle]" /></span>
            <span class="p1 col-12 m-l _subtitle"><ng-content select="[dialogSubtitle]" /></span>
        </h6>
        <!-- close button -->
        <button class="bg-col-5 b-radius-max pos-relative ratio-1-1"
                [style.width.rem]="smallText() ? 2 : 2.5"
                role="button"
                aria-label="Close"
                (click)="close()">
            <i class="flex flex-middle flex-justify-center top-0 left-0 right-0 bottom-0 pos-absolute icon-close"
               [style.font-size.em]="smallText() ? 0.8125 : 0.875"
               aria-hidden="true"></i>
        </button>
    </div>
    <!-- body -->
    <div class="overflow-auto custom-scrollbar m-t-9 m-t-8-s m-t-8-m flex-grow p-l-10 p-r-10 p-r-4-s p-l-4-s"
         [attr.id]="scrollId()">
        <ng-content />
    </div>

    <!-- footer -->
    <div class="w-12 p-l-10 p-r-10 p-r-4-s p-l-4-s p-b-9 p-t-9 p-t-5-s p-b-5-s p-t-5-m p-b-5-m _footer">
        <ng-content select="[dialogFooter]" />
    </div>
</div>